import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative h-screen min-h-[600px] flex items-center justify-center overflow-hidden pt-20" data-id="element-235">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-236">
        <img src="https://images.unsplash.com/photo-1490481651871-ab68de25d43d?auto=format&fit=crop&q=80&w=2000" alt="Elegant woman in fashion attire" className="w-full h-full object-cover object-center" data-id="element-237" />
        <div className="absolute inset-0 bg-brand-dark/30" data-id="element-238" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-4 text-center text-white" data-id="element-239">
        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-5xl md:text-7xl lg:text-8xl font-serif mb-6 leading-tight" data-id="element-240">
          Елегантність у <br className="hidden md:block" data-id="element-241" /> кожній нитці
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="text-lg md:text-xl font-light mb-10 max-w-2xl mx-auto text-white/90" data-id="element-242">
          Преміальний український жіночий одяг, створений для сучасної,
          витонченої жінки. Відкрийте для себе нашу нову колекцію позачасових
          речей.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-243">
          <a href="#catalog" className="w-full sm:w-auto px-8 py-4 bg-brand-cream text-brand-dark rounded-full font-medium hover:bg-white transition-colors" data-id="element-244">
            Переглянути каталог
          </a>
          <a href="https://www.instagram.com/na.lilu" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto px-8 py-4 bg-transparent border border-white text-white rounded-full font-medium hover:bg-white/10 transition-colors" data-id="element-245">
            Стежити в Instagram
          </a>
        </motion.div>
      </div>
    </section>;
}